import Original, {Uniforms} from 'ol/renderer/webgl/VectorTileLayer.js';
import VectorStyleRenderer, {convertStyleToShaders} from '../../render/webgl/VectorStyleRenderer.js';

export default class WebGLVectorLayer extends Original {
    constructor(layer, options) {
        super(layer, options);
    }

    createRenderers_() {
        function addBuilderParams(builder) {
            const exisitingDiscard = builder.getFragmentDiscardExpression();
            const discardFromMask = `texture2D(${Uniforms.TILE_MASK_TEXTURE}, gl_FragCoord.xy / u_pixelRatio / u_viewportSizePx).r * 50. > ${Uniforms.TILE_ZOOM_LEVEL} + 0.5`;
            builder.setFragmentDiscardExpression(
                exisitingDiscard !== 'false'
                    ? `(${exisitingDiscard}) || (${discardFromMask})`
                    : discardFromMask,
            );
            builder.addUniform(Uniforms.TILE_MASK_TEXTURE, 'sampler2D');
            builder.addUniform(Uniforms.TILE_ZOOM_LEVEL, 'float');
        }

        const styleShaders = convertStyleToShaders(this.style_, this.styleVariables_,);
        for (const styleShader of styleShaders) {
            addBuilderParams(styleShader.builder);
        }

        this.styleRenderer_ = new VectorStyleRenderer(
            styleShaders,
            this.styleVariables_,
            this.helper,
            this.hitDetectionEnabled_,
        );
    }
}
